import { rightWidgetsAdministrationConfig as mapissuesRightWidgetsAdministrationConfig } from '@infotech/mapissues'
import {
  administrationConfigAgreementStartWidget,
  administrationConfigAgreementTasksWidget,
  AgreementStartWidget,
  agreementStartWidgetId,
  AgreementTasksWidget,
  agreementTasksWidgetId,
} from '@infotech/agreement'
import { mapissuesModule } from '@infotech/4sides-front-core'

import MapWidget from '../mapissuesConfig/components/MapWidget'
import WorklogWidget from '../mapissuesConfig/components/WorklogWidget'

const { defaultModuleConfig } = mapissuesModule.config

export const rightWidgetsAdministrationConfig = [
  ...mapissuesRightWidgetsAdministrationConfig,
  administrationConfigAgreementStartWidget,
  administrationConfigAgreementTasksWidget,
  {
    id: `issueViewMap`,
    administration: {
      fieldsConfig: {}, 
      title: `Виджет карты`,
    },
  },
  {
    id: `worklog`,
    administration: {
      fieldsConfig: {}, 
      title: `Виджет отчета о проделанной работе`,
    },
  },
]

export const rightWidgetsConfig = {
  ...defaultModuleConfig.routing.read.rightWidgetsConfiguration,
  rightWidgetsMapping: {
    ...defaultModuleConfig.routing.read.rightWidgetsConfiguration.rightWidgetsMapping,
    [agreementStartWidgetId]    : AgreementStartWidget,
    [agreementTasksWidgetId]    : AgreementTasksWidget,
    issueViewMap: MapWidget,
    worklog: WorklogWidget,
  },
}